import { BiCalendar, BiExitFullscreen, BiFullscreen, BiHash, BiPound } from 'react-icons/bi';
import { BsArrowsCollapse } from 'react-icons/bs';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import {
  IoAlertCircle,
  IoCaretDown,
  IoCaretUp,
  IoCheckmarkCircle,
  IoChevronForward,
  IoChevronUp,
  IoCloseCircle,
  IoCloseSharp,
  IoHome,
  IoInformationCircle,
  IoReloadOutline,
} from 'react-icons/io5';
import {
  RiAddFill,
  RiBankCard2Line,
  RiBankCardLine,
  RiCheckboxBlankLine,
  RiCheckboxCircleLine,
  RiCheckboxMultipleBlankLine,
  RiCheckboxMultipleFill,
  RiContrastLine,
  RiEdit2Line,
  RiFilterLine,
  RiMoneyPoundCircleLine,
  RiStickyNoteLine,
  RiTimeLine,
} from 'react-icons/ri';
import {
  TransactionArchive,
  TransactionArchived,
  TransactionMatch,
  TransactionMatched,
  TransactionNotes,
  TransactionRestore,
  TransactionUnmatch,
  TransactionUnmatched,
} from './Icon.custom';

const map = {
  bank: RiMoneyPoundCircleLine,
  calendar: BiCalendar,
  card: RiBankCardLine,
  'card type': RiBankCard2Line,
  'caret down': IoCaretDown,
  'caret up': IoCaretUp,
  'check circle': RiCheckboxCircleLine,
  'chevron right': IoChevronForward,
  'chevron up': IoChevronUp,
  close: IoCloseSharp,
  collapse: BsArrowsCollapse,
  edit: RiEdit2Line,
  'ellipsis vertical': HiOutlineDotsVertical,
  error: IoCloseCircle,
  deselect: RiCheckboxBlankLine,
  filter: RiFilterLine,
  fullscreen: BiFullscreen,
  'fullscreen exit': BiExitFullscreen,
  hash: BiHash,
  home: IoHome,
  info: IoInformationCircle,
  note: RiStickyNoteLine,
  plus: RiAddFill,
  pound: BiPound,
  reload: IoReloadOutline,
  'select all': RiCheckboxMultipleFill,
  'select none': RiCheckboxMultipleBlankLine,
  success: IoCheckmarkCircle,
  'theme switch': RiContrastLine,
  time: RiTimeLine,
  'transaction archive': TransactionArchive,
  'transaction archived': TransactionArchived,
  'transaction match': TransactionMatch,
  'transaction matched': TransactionMatched,
  'transaction notes': TransactionNotes,
  'transaction restore': TransactionRestore,
  'transaction unmatch': TransactionUnmatch,
  'transaction unmatched': TransactionUnmatched,
  warning: IoAlertCircle,
};

export default map;
